/**
 * Time app routes — alle `/time/*`, `/app/time`, `/embed/time` ruter samt
 * legacy redirects (Bridge → Time, /pricing → /time/pricing).
 *
 * REMIX: ved remix til ny app erstattes denne fil med din nye apps routes,
 * og importen i `src/App.tsx` skiftes ud (én linje). Foundation-koden
 * (Studio, Auth, Dashboard) røres ikke.
 */
import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const NordicTimeLandingPage = lazy(() => import("@/pages/NordicTimeLandingPage"));
const NordicTimePricing = lazy(() => import("@/pages/NordicTimePricing"));
const TimeCheckoutTest = lazy(() => import("@/pages/TimeCheckoutTest"));
const TimeApp = lazy(() => import("./pages/TimeApp"));
const EmbedTime = lazy(() => import("./pages/EmbedTime"));

/** Renders alle Time-specifikke routes inde i en <Routes>-tree. */
export function TimeAppRoutes() {
  return (
    <>
      {/* Time landing + pricing */}
      <Route path="/time" element={<NordicTimeLandingPage />} />
      <Route path="/time/pricing" element={<NordicTimePricing />} />
      <Route path="/time/partner" element={<Navigate to="/time" replace />} />
      <Route path="/time/checkout-test" element={<TimeCheckoutTest />} />

      {/* App + embed */}
      <Route path="/app/time" element={<TimeApp />} />
      <Route path="/embed/time" element={<EmbedTime />} />

      {/* Legacy: Bridge er arkiveret → Time */}
      <Route path="/bridge" element={<Navigate to="/time" replace />} />
      <Route path="/bridge/*" element={<Navigate to="/time" replace />} />
      <Route path="/app/bridge" element={<Navigate to="/app/time" replace />} />
      <Route path="/embed/bridge" element={<Navigate to="/embed/time" replace />} />

      {/* Legacy: generic /pricing → Time pricing */}
      <Route path="/pricing" element={<Navigate to="/time/pricing" replace />} />
      <Route path="/dashboard/billing" element={<Navigate to="/time/pricing" replace />} />
    </>
  );
}
